import ButtonBase, { type ButtonBaseProps } from '@mui/material/ButtonBase';
import Tooltip from '@mui/material/Tooltip';
import { forwardRef } from 'react';
import { controlHeight, radius } from '@/shared/theme';

interface TileIconButtonProps extends ButtonBaseProps {
  /** Accessible name; also shown as tooltip. */
  label: string;
  size?: number;
}

/** Square bordered icon button from the prototype header (theme, bell, menu). */
export const TileIconButton = forwardRef<HTMLButtonElement, TileIconButtonProps>(
  function TileIconButton({ label, size = controlHeight.md, sx, children, ...props }, ref) {
    return (
      <Tooltip title={label}>
        <ButtonBase
          ref={ref}
          aria-label={label}
          sx={[
            (theme) => ({
              position: 'relative',
              flex: 'none',
              width: size,
              height: size,
              borderRadius: radius.control,
              border: `1px solid ${theme.vars.palette.md.border}`,
              background: theme.vars.palette.md.panel,
              color: theme.vars.palette.md.muted,
              transition: 'transform .14s',
              '&:hover': {
                background: `color-mix(in srgb, ${theme.vars.palette.md.text} 8%, transparent)`,
                color: theme.vars.palette.md.text,
              },
              '&:active': { transform: 'scale(.94)' },
              '&.Mui-focusVisible': {
                outline: `2px solid ${theme.vars.palette.primary.main}`,
                outlineOffset: 2,
              },
            }),
            ...(Array.isArray(sx) ? sx : [sx]),
          ]}
          {...props}
        >
          {children}
        </ButtonBase>
      </Tooltip>
    );
  },
);
